import type { Action } from "@reduxjs/toolkit";
import { createAction } from "@reduxjs/toolkit";

import type { UniversalTabValue } from "@js/apps/universal-search/constants";
import { Events } from "@js/services/analytics";
import type { Freelancer } from "@js/types/freelancer";
import type { Job } from "@js/types/jobs";

type SearchQueryId = number;
type DefaultPopover = "jobs" | "talent";
type JobId = Job["id"];
type TalentId = Freelancer["id"];
type ResultPosition = number;

type SearchPopoverTabClickedPayload = {
  search_query_id?: SearchQueryId;
  default_popover: DefaultPopover;
};

type JobResultItemClickedPayload = {
  job_id: JobId;
  search_query_id?: SearchQueryId;
  result_position: ResultPosition;
};

type TalentResultListItemClickedPayload = {
  talent_id: TalentId;
  search_query_id?: SearchQueryId;
  result_position: ResultPosition;
};

type JobViewAllPopoverClickedPayload = {
  search_query_id?: SearchQueryId;
};

type TalentViewAllPopoverClickedPayload = {
  search_query_id?: SearchQueryId;
};

export const globalSearchClickAndTyped = createAction(
  Events.CLICK_GLOBAL_SEARCH,
);
const jobTabClicked = createAction<SearchPopoverTabClickedPayload>(
  Events.CLICK_JOB_RESULTS_POPOVER_SEARCH,
);
export const jobResultListItemClicked =
  createAction<JobResultItemClickedPayload>(
    Events.CLICK_VIEW_JOB_POPOVER_SEARCH,
  );
export const talentResultListItemClicked =
  createAction<TalentResultListItemClickedPayload>(
    Events.CLICK_TALENT_POPOVER_SEARCH,
  );

const peopleTabClicked = createAction<SearchPopoverTabClickedPayload>(
  Events.CLICK_PEOPLE_RESULTS_POPOVER_SEARCH,
);
export const jobViewAllPopoverClicked =
  createAction<JobViewAllPopoverClickedPayload>(
    Events.CLICK_JOB_VIEW_ALL_POPOVER_SEARCH,
  );
export const talentViewAllPopoverClicked =
  createAction<TalentViewAllPopoverClickedPayload>(
    Events.CLICK_TALENT_VIEW_ALL_POPOVER_SEARCH,
  );

export const logTabClicked = (
  clickedTab: UniversalTabValue,
  currentTab: UniversalTabValue,
  searchEventId?: number,
): Action => {
  const defaultTab: Record<UniversalTabValue, DefaultPopover> = {
    JOBS: "jobs",
    PEOPLE: "talent",
  };
  const payload = {
    default_popover: defaultTab[currentTab],
    search_query_id: searchEventId,
  };

  if (clickedTab === "JOBS") {
    return jobTabClicked(payload);
  }
  return peopleTabClicked(payload);
};
